module.exports = __webpack_public_path__ + "img/example_dix_image_sm.bad2c3f9.png";